import React from 'react';
import WorkflowTemplate from '../../components/WorkflowTemplate';
import { LEAD_STAGES } from 'models/Lead';

const WorkflowOfferPage: React.FC = () => (
  <WorkflowTemplate page={LEAD_STAGES.OFFER} />
);

export default WorkflowOfferPage;
